


















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PersetujuanTransfusiDarahTabPage from "./PersetujuanTransfusiDarahTabPage.vue";
import PersetujuanTransfusiInkompatibelTabPage from "./PersetujuanTransfusiInkompatibelTabPage.vue";
import PersetujuanPlebotomiTabPage from "./PersetujuanPlebotomiTabPage.vue";
import {
  JenisPersetujuanLayananDarah,
  OpsiPersetujuanLayananDarah,
  PERSETUJUAN_LAYANAN_DARAH
} from "./persetujuanLayananDarah";
import StorePersetujuanTransfusiDarah from "@/store/modules/PersetujuanTransfusiDarah";
import StorePersetujuanTransfusiInkompatibel from "@/store/modules/PersetujuanTransfusiInkompatibel";
import StorePersetujuanPlebotomi from "@/store/modules/PersetujuanPlebotomi";
import { userModule } from "@/store/modules/user";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";

interface OpsiTambah extends OpsiPersetujuanLayananDarah {
  alasan: string;
}

const STORE_PER_JENIS: Record<JenisPersetujuanLayananDarah, any> = {
  transfusi: StorePersetujuanTransfusiDarah,
  inkompatibel: StorePersetujuanTransfusiInkompatibel,
  plebotomi: StorePersetujuanPlebotomi
};

@Component({
  components: {
    PersetujuanTransfusiDarahTabPage,
    PersetujuanTransfusiInkompatibelTabPage,
    PersetujuanPlebotomiTabPage
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PersetujuanLayananDarahTabPage extends Vue {
  @Prop() readonly register!: string;

  isReadOnly!: () => boolean;

  jenisAktif: JenisPersetujuanLayananDarah = "transfusi";

  daftarJenis = PERSETUJUAN_LAYANAN_DARAH;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get jumlah(): Record<JenisPersetujuanLayananDarah, number> {
    return {
      transfusi: StorePersetujuanTransfusiDarah.suket.length,
      inkompatibel: StorePersetujuanTransfusiInkompatibel.suket.length,
      plebotomi: StorePersetujuanPlebotomi.suket.length
    };
  }

  get perluSoap(): boolean {
    const unit = String(userModule.user.unit_id || "");

    if (unit === "01" || unit > "35") return false;

    return !storeSoap.detailSoap.length;
  }

  get opsiTambah(): OpsiTambah[] {
    return PERSETUJUAN_LAYANAN_DARAH.filter(opsi => this.bolehBuat(opsi)).map(
      opsi => ({
        ...opsi,
        alasan: !storePasien.identitasPasien
          ? "Memuat data pasien…"
          : this.perluSoap
          ? "Isi SOAP & Diagnosis kunjungan ini terlebih dahulu"
          : ""
      })
    );
  }

  bolehBuat(opsi: OpsiPersetujuanLayananDarah): boolean {
    if (userModule.canAccessForm(opsi.accessCode, "create")) return true;

    return userModule.user.profesi === "Dokter";
  }

  mounted() {
    this.muat();
  }

  @Watch("register")
  onRegisterChange() {
    this.muat();
  }

  muat() {
    if (!this.register) return;

    Object.values(STORE_PER_JENIS).forEach(store => {
      if (store.registerId !== String(this.register)) {
        store.getSuketByRegister(this.register);
      }
    });
  }

  tambah(jenis: JenisPersetujuanLayananDarah) {
    this.jenisAktif = jenis;

    this.$nextTick(() => {
      const halaman = this.$refs[jenis] as any;

      if (halaman && typeof halaman.add === "function") {
        halaman.add();
      }
    });
  }

  teruskanPageTab(tab: string) {
    this.$emit("pageTab", tab);
  }
}
